import { Grid, Card, Box, Typography, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import Indexdasbord from "../../../composant/navbar/indexDashbord";
import { Api_Token } from "../../../env";
import Datepicker from "react-tailwindcss-datepicker";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import NumberGeneral from "../../../composant/statistique/CardStatistique";

function SalesChart({ labels, Data, totals, currentLabel, previousLabel }) {
  const chartOptions = {
    chart: { type: "line", height: 350, toolbar: { show: false } },
    stroke: { curve: "smooth", width: [3, 3], dashArray: [0, 8] },
    colors: ["#10B981", "#06B6D4"],
    xaxis: { categories: labels, labels: { rotate: -45 } },
    yaxis: {
      labels: { formatter: (val) => `MAD ${val.toFixed(0)}` },
    },
    legend: { show: false, position: "top" },
    tooltip: {
      y: { formatter: (val) => `MAD ${val}` },
    },
  };

  const percentageChange =
    totals.previous === 0
      ? totals.current === 0
        ? 0
        : 100
      : ((totals.current - totals.previous) / totals.previous) * 100;

  const isNegative = percentageChange < 0;

  return (
    <div>
      <Card sx={{ padding: 2, marginBottom: 3 }}>
        <Typography variant="subtitle2" color="text.secondary">
          Gross sales&nbsp;
        </Typography>

        <Stack direction="row" spacing={4} alignItems="flex-end" mt={1}>
          {/* Current Period */}
          <Box>
            <Box sx={{ display: "flex" }}>
              <Typography variant="h5" fontWeight="bold">
                {totals.current.toFixed(2)}
              </Typography>
              <Stack direction="row" alignItems="center" spacing={0.5}>
                {isNegative ? (
                  <ArrowDropDownIcon color="error" fontSize="small" />
                ) : (
                  <ArrowDropUpIcon color="success" fontSize="small" />
                )}
                <Typography
                  variant="body2"
                  color={isNegative ? "error.main" : "success.main"}
                >
                  {Math.abs(percentageChange).toFixed(0)}%
                </Typography>
              </Stack>
            </Box>

            <Typography variant="caption" color="text.secondary">
              <Box
                component="span"
                sx={{
                  color: "#10B981",
                  width: 8,
                  height: 2,
                  bgcolor: "success.main",
                  display: "inline-block",
                  mr: 1,
                }}
              />
              {currentLabel}
            </Typography>
          </Box>

          {/* Previous Period */}
          <Box>
            <Typography variant="h5" fontWeight="bold">
              {totals.previous.toFixed(2)}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              <Box
                component="span"
                sx={{
                  color: "#06B6D4",
                  width: 8,
                  height: 2,
                  borderTop: "2px dotted",
                  borderColor: "success.main",
                  display: "inline-block",
                  mr: 1,
                }}
              />
              {previousLabel}
            </Typography>
          </Box>
        </Stack>

        <Chart options={chartOptions} series={Data} type="line" height={350} />
      </Card>
    </div>
  );
}
const formatDate = (date) =>
  new Date(date).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

const getDateRangeLabels = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const diffDays = Math.ceil((end - start) / (1000 * 60 * 60 * 24)) + 1;

  const previousEnd = new Date(start);
  previousEnd.setDate(start.getDate() - 1);

  const previousStart = new Date(previousEnd);
  previousStart.setDate(previousEnd.getDate() - diffDays + 1);

  return {
    currentLabel: `${formatDate(start)} - ${formatDate(end)}`,
    previousLabel: `${formatDate(previousStart)} - ${formatDate(previousEnd)}`,
  };
};

function CommandChart({ labels, Data, totals, currentLabel, previousLabel }) {
  const chartOptions = {
    chart: { type: "line", height: 350, toolbar: { show: false } },
    stroke: { curve: "smooth", width: [3, 3], dashArray: [0, 8] },
    colors: ["#10B981", "#06B6D4"],
    xaxis: { categories: labels, labels: { rotate: -45 } },
    yaxis: {
      labels: { formatter: (val) => `${val.toFixed(0)}` },
    },
    legend: { show: false, position: "top" },
    tooltip: {
      y: { formatter: (val) => `${val}` },
    },
  };

  const percentageChange =
    totals.previous === 0
      ? totals.current === 0
        ? 0
        : 100
      : ((totals.current - totals.previous) / totals.previous) * 100;

  const isNegative = percentageChange < 0;

  return (
    <div>
      <Card sx={{ padding: 2, marginBottom: 3 }}>
        <Typography variant="subtitle2" color="text.secondary">
          Orders&nbsp;
        </Typography>

        <Stack direction="row" spacing={4} alignItems="flex-end" mt={1}>
          {/* Current Period */}
          <Box>
            <Box sx={{ display: "flex" }}>
              <Typography variant="h5" fontWeight="bold">
                {totals.current.toFixed(2)}
              </Typography>
              <Stack direction="row" alignItems="center" spacing={0.5}>
                {isNegative ? (
                  <ArrowDropDownIcon color="error" fontSize="small" />
                ) : (
                  <ArrowDropUpIcon color="success" fontSize="small" />
                )}
                <Typography
                  variant="body2"
                  color={isNegative ? "error.main" : "success.main"}
                >
                  {Math.abs(percentageChange).toFixed(0)}%
                </Typography>
              </Stack>
            </Box>

            <Typography variant="caption" color="text.secondary">
              <Box
                component="span"
                sx={{
                  color: "#10B981",
                  width: 8,
                  height: 2,
                  bgcolor: "success.main",
                  display: "inline-block",
                  mr: 1,
                }}
              />
              {currentLabel}
            </Typography>
          </Box>

          {/* Previous Period */}
          <Box>
            <Typography variant="h5" fontWeight="bold">
              {totals.previous.toFixed(2)}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              <Box
                component="span"
                sx={{
                  color: "#06B6D4",
                  width: 8,
                  height: 2,
                  borderTop: "2px dotted",
                  borderColor: "success.main",
                  display: "inline-block",
                  mr: 1,
                }}
              />
              {previousLabel}
            </Typography>
          </Box>
        </Stack>

        <Chart options={chartOptions} series={Data} type="line" height={350} />
      </Card>
    </div>
  );
}

export function Statistique() {
  const [DateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
  });
  const [labels, setLabels] = useState([]);
  const [Data, setData] = useState({ order: [], sale: [] });
  const [totals, setTotals] = useState({
    order: { current: 0, previous: 0 },
    sale: { current: 0, previous: 0 },
  });
  const startDate =
    DateRange?.startDate ||
    new Date(new Date().setDate(new Date().getDate() - 7));
  const endDate = DateRange?.endDate || new Date();
  const { currentLabel, previousLabel } = getDateRangeLabels(
    startDate,
    endDate
  );

  useEffect(() => {
    const startDate =
      DateRange?.startDate ||
      new Date(new Date().setDate(new Date().getDate() - 7));
    const endDate = DateRange?.endDate || new Date();

    const url = `command/GetSalesLineChartData?startDate=${
      startDate.toISOString().split("T")[0]
    }&endDate=${endDate.toISOString().split("T")[0]}`;

    Api_Token.get(url).then((res) => {
      const { labels, series } = res.data;
      setLabels(labels);
      setData({
        order: series.slice(2, 4),
        sale: series.slice(0, 2),
      });
      if (series.length >= 2) {
        console.log("series : ", series);
        const currentTotalsale = series[0].data.reduce(
          (acc, val) => acc + val,
          0
        );
        const previousTotalsale = series[1].data.reduce(
          (acc, val) => acc + val,
          0
        );
        const currentTotalOrder = series[2].data.reduce(
          (acc, val) => acc + val,
          0
        );
        const previousTotalOrder = series[3].data.reduce(
          (acc, val) => acc + val,
          0
        );
        setTotals({
          order: { current: currentTotalOrder, previous: previousTotalOrder },
          sale: { current: currentTotalsale, previous: previousTotalsale },
        });
      }
    });
  }, [DateRange]);
  console.log(Data);
  return (
    <Grid container sx={{ padding: "2%" }} spacing={2}>
      <Grid item xs={6}>
        <Typography variant="h4">Dashboard</Typography>
      </Grid>
      <Grid item xs={6}>
        <Datepicker
          inputClassName="w-full h-14 rounded-md focus:ring-0 font-normal bg-white border border-gray-300 placeholder:text-black-100 text-black dark:bg-black-900 dark:placeholder:text-black-100"
          primaryColor={"blue"}
          value={DateRange}
          onChange={(newDateRange) => {
            setDateRange(newDateRange);
          }}
          showShortcuts={true}
          showFooter={true}
          popoverDirection="down"
        />
      </Grid>
      <Grid item xs={12}>
        <SalesChart
          labels={labels}
          Data={Data.sale}
          totals={totals.sale}
          currentLabel={currentLabel}
          previousLabel={previousLabel}
        />
      </Grid>
      <Grid item xs={12}>
        <CommandChart
          labels={labels}
          Data={Data.order}
          totals={totals.order}
          currentLabel={currentLabel}
          previousLabel={previousLabel}
        />
      </Grid>
      <Grid item xs={12}>
        <NumberGeneral DateRange={DateRange} />
      </Grid>
    </Grid>
  );
}

export default function Pagedashboard() {
  return <Indexdasbord Children={<Statistique />} />;
}
